var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDiagRightUp = function SvgArrowDiagRightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-diag-right-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.584 9.094v3.02h19.063L27.303 32.457 6.96 52.801l2.12 2.12 2.12 2.12 20.343-20.344 20.343-20.344v19.063h6.04V6.075H28.584z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDiagRightUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI4LjU4NDEgOS4wOTQ0NVYxMi4xMTRIMzguMTE1M0g0Ny42NDY1TDI3LjMwMzIgMzIuNDU3NEw2Ljk1OTcyIDUyLjgwMDlMOS4wNzk0NyA1NC45MjA2TDExLjE5OTIgNTcuMDQwM0wzMS41NDI3IDM2LjY5NjlMNTEuODg2MSAxNi4zNTM1VjI1Ljg4NDhWMzUuNDE2SDU0LjkwNTZINTcuOTI1MVYyMC43NDU1VjYuMDc0OTVINDMuMjU0NkgyOC41ODQxVjkuMDk0NDVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";